import { cn } from '@aether/ui/utils';

export const PoweredBy = ({ size = 'small', className }: { size?: 'small' | 'large'; className?: string }) => {
  return (
    <div className={cn('text-gray-400', size === 'large' ? 'text-2xl' : 'text-base', className)}>
      <span className={cn(size === 'large' ? 'text-base' : 'text-[11px]')}>powered by </span>
      <span className="font-bold">arabesque</span>
      <span className="ml-0.5">ai</span>
    </div>
  );
};
